<template>
  <el-dialog
    title="轮询设置"
    :visible="visible"
    width="720px"
    :destroy-on-close="true"
    :lock-scroll="false"
    custom-class="ele-dialog-form"
    @update:visible="updateVisible">
    <el-form ref="form" :model="form" :rules="rules" label-width="100px">
      <el-form-item label="轮询方式:" prop="channel">
        <el-radio-group v-model="form.channel">
          <el-radio
            v-for="item in pollModeOptions"
            :key="'poll-' + item.value"
            :label="item.value">{{ item.label }}</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-table v-loading="tableLoading" :data="channelList" stripe border>
        <el-table-column label="通道名称" align="center" min-width="160" show-overflow-tooltip>
          <template slot-scope="{ row }">
            {{ row.up_channel_name }}
          </template>
        </el-table-column>
        <el-table-column label="通道权重" align="center" width="180">
          <template slot-scope="{ row }">
            <el-input
              v-model="row.num"
              clearable
              placeholder="请输入"
              :disabled="!isWeightMode" />
          </template>
        </el-table-column>
        <el-table-column label="轮询开关" align="center" width="160">
          <template slot-scope="{ row }">
            <el-switch v-model="row.isopen" :active-value="1" :inactive-value="0" />
          </template>
        </el-table-column>
      </el-table>
    </el-form>
    <div slot="footer">
      <el-button @click="updateVisible(false)">取消</el-button>
      <el-button type="primary" :loading="loading" @click="save">确定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { loadDictOptions } from '@/utils/dict';

const POLL_MODE = {
  DEFAULT: 0,
  SEQUENTIAL: 1,
  WEIGHT: 2,
  SUCCESS: 3
};

export default {
  name: 'RoundEdit',
  props: {
    visible: Boolean,
    data: Object
  },
  data() {
    return {
      form: { id: 0, channel: POLL_MODE.DEFAULT },
      rules: {
        channel: [{ required: true, type: 'number', message: '请选择', trigger: 'change' }]
      },
      loading: false,
      tableLoading: false,
      channelList: [],
      pollModeOptions: []
    };
  },
  computed: {
    isWeightMode() {
      return Number(this.form.channel) === POLL_MODE.WEIGHT;
    }
  },
  watch: {
    visible(val) {
      if (val) {
        this.onOpen();
      }
    }
  },
  mounted() {
    loadDictOptions('poll_mode', { numberValue: true })
      .then((list) => {
        this.pollModeOptions = list || [];
      })
      .catch((e) => {
        this.$message.error(e.message);
      });
  },
  methods: {
    onOpen() {
      this.initForm();
      this.queryChannelList();
    },
    initForm() {
      const row = this.data || {};
      const channel = Number(row.channel);
      this.form = {
        id: Number(row.id) || 0,
        channel: Number.isFinite(channel) ? channel : POLL_MODE.DEFAULT
      };
      this.$nextTick(() => {
        if (this.$refs.form) {
          this.$refs.form.clearValidate();
        }
      });
    },
    queryChannelList() {
      if (!this.form.id) {
        this.channelList = [];
        return;
      }
      this.tableLoading = true;
      this.$http.post('/channeltype/getchannelsRoundList', {
        channel_type_id: this.form.id
      }).then((res) => {
        this.tableLoading = false;
        if (res.data.code === 0) {
          this.channelList = (res.data.data || []).map((item) => ({
            ...item,
            num: item.num === null || item.num === undefined || item.num === '' ? 0 : Number(item.num) || 0,
            isopen: Number(item.isopen) === 1 ? 1 : 0
          }));
        } else {
          this.channelList = [];
          this.$message.error(res.data.msg);
        }
      }).catch((e) => {
        this.tableLoading = false;
        this.$message.error(e.message);
      });
    },
    save() {
      this.$refs.form.validate((valid) => {
        if (!valid) {
          return;
        }
        const mode = Number(this.form.channel);
        if (![POLL_MODE.DEFAULT, POLL_MODE.SEQUENTIAL, POLL_MODE.WEIGHT, POLL_MODE.SUCCESS].includes(mode)) {
          this.$message.error('请选择');
          return;
        }
        if (!this.channelList.length) {
          this.$message.error('暂无可保存的通道');
          return;
        }

        const openRows = this.channelList.filter((item) => Number(item.isopen) === 1);
        if (!openRows.length) {
          this.$message.error('请至少开启一个通道参与轮询');
          return;
        }

        const attrArr = this.channelList.map((item) => ({
          channel_round_id: Number(item.channel_round_id) || 0,
          channel_type_id: Number(item.channel_type_id) || this.form.id,
          channel_id: Number(item.channel_id),
          num: Math.max(0, parseInt(item.num, 10) || 0),
          isopen: Number(item.isopen) === 1 ? 1 : 0
        }));

        this.loading = true;
        this.$http.post('/channeltype/save', {
          channel_type_id: this.form.id,
          channel: mode,
          json: JSON.stringify(attrArr)
        }).then((res) => {
          this.loading = false;
          if (res.data.code === 0) {
            this.$message.success(res.data.msg);
            this.updateVisible(false);
            this.$emit('done');
          } else {
            this.$message.error(res.data.msg);
          }
        }).catch((e) => {
          this.loading = false;
          this.$message.error(e.message);
        });
      });
    },
    updateVisible(value) {
      this.$emit('update:visible', value);
    }
  }
};
</script>

<style scoped></style>
